<template>
  <div v-show="widgetOptions.showStatement == 1" id="adabundle-accessibility-statement-box">
        <button id="adabundle-close-statement-btn" aria-label="Close Accessibility Statement"></button>
        <div class="adabundle-statement-content">
            <div>
                <!-- <h3>Accessibility Statement</h3> -->
                <div v-html="widgetOptions.statementText"></div>
            </div>

            <p>
                
            </p>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Utility from '../common/Utility';
import  HTTP from "../common/Http";

export default {
  name: "AccessibilityStatement",
  components: {
  },
  mounted(){
     
  },
  data () {
    return {
      isLoading: false, 
    }
  },
  computed: {
    ...mapState([
      "timeStamp",
      "wid",
      "widgetOptions",
    ])
  },
  methods: {
   
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
